import Cookies from 'js-cookie';

function TicketsController($scope, $rootScope, $route, MyTicketsMonthYearSvc, $location, PlanSvc, $routeParams) {
	"ngInject";

  jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') === undefined) {
          var date = new Date();
          var minutes = 60000;
          date.setTime(date.getTime() + (minutes * 60 * 1000));
          Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
          $location.path('/connect').replace();
          $route.reload();
      }
  });


  var d = new Date();
  //JS Month is a zero based array.
  Month = (d.getMonth() + 1)
  //Format to include a zero on single digit months
  $scope.CurrentMonth = Month < 10 ? '0' + Month : '' + Month;
  $scope.CurrentYear = d.getFullYear().toString();
    
  $scope.ChangeYear = function(Year)
  {
      $scope.CurrentYear = Year;
      $scope.GetTickets();
  }

  $scope.ChangeMonth = function (Month) {
      $scope.CurrentMonth = Month;
      $scope.GetTickets();
  }

  $scope.ChangeMonthYear = function (Month, Year) {
      $scope.CurrentMonth = Month;
      $scope.CurrentYear = Year;
      $scope.GetTickets();
  }

  $scope.ShowPriorDraw = function (drawdate) {
      if (new Date(drawdate) < new Date(d)) {
        //  console.log('true' + drawdate + d);
          return true;
      }
      else {
        //  console.log('false' + drawdate + d);
          return false;
      }
  }
  $scope.ShowFutureDraw = function (drawdate) {
      if (new Date(drawdate) > new Date(d)) {
          return true;
      }
      else {
          return false;
      }
  }
  $scope.ShowCurrentDraw = function (drawdate) {
      if (new Date(drawdate).getDate() - 7 < new Date(d) && new Date(drawdate) > new Date(d)) {
          return true;
      }
      else {
          return false;
      }
  }

  $scope.GetTickets = function()
  {
      jQuery(document).ready(function ($) {
          MyTicketsMonthYearSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), Year: $scope.CurrentYear, Month: $scope.CurrentMonth }, function (data) {
              $scope.Tickets = data;
          });
      });
  }

  $scope.GetTickets();

};

export default {
  name: 'ticketsController',
  fn: TicketsController
}